// Returns the URL a given notification should navigate to.
// Returns null if the notification points nowhere useful (e.g., missing deal id).
//
// Notification types in use:
//   - "newtask"               → task assignment on a deal
//   - "deadline"              → task deadline reminder
//   - "mention"               → chat or note mention on a deal
//   - "pending-approval"      → sale turn-in needing review
//   - "pending-file"          → file request needing creation
//   - "approved-for-accounting" → deal approved → accountant's approvals queue
//   - "commission-flagged"    → accountant flagged a deal's numbers
//   - "contact-shared"        → a teammate shared a contact (dealid = contact id)
//   - "file-completed"        → requesting agent informed file is ready
//   - "post-reaction"         → reaction on a Feed post (NOT a deal id)
//   - "oh-request"            → LC notified of agent's open house request
//   - "oh-approved"           → agent notified their request was approved
//   - "oh-declined"           → agent notified their request was declined
//   - "followup"              → past-client check-in came due (dealid = plan id)
export function urlForNotification(n) {
  if (!n) return null;

  // Feed post reactions: the `dealid` field actually holds the post id.
  if (n.type === "post-reaction") {
    return "/dashboard/feed";
  }

  // Up-for-grabs open houses route to the Open Houses page's board, not a deal.
  if (n.type === "oh-request" || n.type === "oh-approved" || n.type === "oh-declined") {
    return "/dashboard/open-houses?tab=up-for-grabs";
  }

  // Accountants land on their approvals queue, not one deal's detail page.
  if (n.type === "approved-for-accounting") {
    return "/dashboard/commission-approvals";
  }

  // A shared contact lives on the Contacts page (the `dealid` field carries
  // the contact id, not a deal).
  if (n.type === "contact-shared") {
    return "/dashboard/contact";
  }

  // Past-client check-ins land on the Follow-Ups queue, not one deal's detail
  // page (the `dealid` field carries the follow-up plan id, not a deal).
  if (n.type === "followup") {
    return "/dashboard/follow-ups";
  }

  // Everything else is deal-scoped.
  if (!n.dealid) return null;

  if (n.type === "mention") {
    return `/dashboard/deals-detail/${n.dealid}?type=chat`;
  }

  if (n.type === "newtask" || n.type === "deadline") {
    const taskQuery = n.taskid ? `taskId=${n.taskid}` : "";
    return `/dashboard/deals-detail/${n.dealid}${taskQuery ? `?${taskQuery}` : ""}`;
  }

  return `/dashboard/deals-detail/${n.dealid}`;
}
